import { render, staticRenderFns } from "./mobileApp.vue?vue&type=template&id=643d1f1c&"
import script from "./mobileApp.vue?vue&type=script&lang=js&"
export * from "./mobileApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports